import * as MutationTypes from './mutationTypes';
import * as api from './api';
import { MenuRecommendation } from './models/menuRecommendation';
import { PeriodEngineeringProfitability, MenuRecommendationPreview } from './models';

export const menuRecommendationRequest = async ({ commit }, menuEngineeringRecommendationGuid) => {
  const response = await api.menuRecommendationRequest(menuEngineeringRecommendationGuid);
  const menu = MenuRecommendation.toInstance(response.data);
  commit(MutationTypes.MENU_RECOMMENDATION_SUCCESS, menu);
  return menu;
};

export const menuRecommendationListRequest = async ({ commit }, predictionPeriodGuid) => {
  const response = await api.menuRecommendationListRequest(predictionPeriodGuid);
  const menuRecommendationList = MenuRecommendationPreview.toInstanceList(response.data);
  commit(MutationTypes.MENU_RECOMMENDATION_LIST_SUCCESS, menuRecommendationList);
  return menuRecommendationList;
};

export const saveMenuRecommendationRequest = async ({ commit, dispatch, getters: { menuRecommendation, menuRecommendationList } }, { periodGuid, menuRecommendationGuid }) => {
  const serializedMenuRecommendation = menuRecommendation.serialize();
  await api.saveMenuRecommendationRequest(menuRecommendationGuid, serializedMenuRecommendation);
  commit(MutationTypes.VALIDATE_MENU_ENGINEERING_RECOMMENDATION, menuRecommendationGuid);
  const notValidatedRecommendations = menuRecommendationList.filter((m) => !m.isRecommendationValidated && m.guid !== menuRecommendationGuid);
  if (notValidatedRecommendations.length === 0) {
    await dispatch('validatePeriodEngineering', periodGuid);
  }
};

export const setMenuEngineeringSectionConfirmed = async ({ commit }, { sectionGuid, confirmed }) => {
  commit(MutationTypes.MENU_ENGINEERING_SECTION_SET_CONFIRMED, { sectionGuid, confirmed });
};

export const saveMenuEngineeringSection = async ({ commit }, { sectionGuid, demandObject }) => {
  commit(MutationTypes.MENU_ENGINEERING_MODIFY_SECTION, { sectionGuid, demandObject });
};

// Used to get profitability for all menus
export const periodEngineeringProfitabilityRequest = async ({ commit }, periodGuid) => {
  const response = await api.menuEngineeringProfitabilityRequest(periodGuid);
  const periodEngineeringProfitability = PeriodEngineeringProfitability.toInstance(response.data);
  commit(MutationTypes.PERIOD_ENGINEERING_PROFITABILITY_SUCCESS, periodEngineeringProfitability);
};

// Used to get profitability for one menu
export const menuProfitabilityRequest = async ({ commit }, { periodGuid, menuGuid }) => {
  const response = await api.menuEngineeringProfitabilityRequest(periodGuid, menuGuid);
  const periodEngineeringProfitability = PeriodEngineeringProfitability.toInstance(response.data);
  commit(MutationTypes.MENU_ENGINEERING_PROFITABILITY_SUCCESS, {
    periodEngineeringProfitability,
    menuGuid
  });
};

export const sectionProfitabilityRequest = async (
  { commit, getters },
  { periodGuid, menuGuid, sectionGuids }
) => {
  // Get changes in section level or in menu level
  const sectionChanges = getters.getSectionChangesByGuids(sectionGuids);
  const sectionChangesSerialized = sectionChanges.map((sc) => sc.serialize());

  const response = await api.menuEngineeringProfitabilityRequest(periodGuid, menuGuid, sectionChangesSerialized);
  const periodEngineeringProfitability = PeriodEngineeringProfitability.toInstance(response.data);

  // Commit changes by section, menu or period
  commit(MutationTypes.SECTION_ENGINEERING_PROFITABILITY_SUCCESS, {
    periodEngineeringProfitability,
    menuGuid,
    sectionGuids
  });
};

export const sectionByDemandProfitabilityRequest = async (
  { commit },
  { periodGuid, menuGuid, sectionModified }
) => {
  // Get changes in section level or in menu level
  const sectionChange = sectionModified.getChange();
  const sectionChangeSerialized = sectionChange.serialize();

  const response = await api.menuEngineeringProfitabilityRequest(periodGuid, menuGuid, [sectionChangeSerialized]);
  const periodEngineeringProfitability = PeriodEngineeringProfitability.toInstance(response.data);

  // Commit changes by section, menu or period
  commit(MutationTypes.SECTION_ENGINEERING_PROFITABILITY_SUCCESS, {
    periodEngineeringProfitability,
    menuGuid,
    sectionGuids: [sectionModified.guid]
  });
};

export const setEngineeringProfitabilityLoading = ({ commit }, isLoading) => {
  commit(MutationTypes.SET_ENGINEERING_PROFITABILITY_LOADING, isLoading);
};
